export const noop = /* nosonar */ () => {};
export const noopAsync = /* nosonar */ async (): Promise<any> => {};
